<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :sort-options="{
        enabled: true,
        initialSortBy: [
          {field: 'nen', type: 'desc'},
          {field: 'AB', type: 'desc'},
        ]
      }"
      class="table_row"
      style="overflow: visible;"
      :pagination-options="{
        enabled: true,
        perPage: 15,
        perPageDropdown: [5, 10, 15, 20, 30, 40, 50],
        dropdownAllowAll: false,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: '表示件数',
        ofLabel: 'of',
        pageLabel: 'page', // for 'pages' mode
        allLabel: 'All',
      }"
    >
    <template slot="table-row" slot-scope="props">
      <span v-if="props.column.field == 'index'" >
        <b-dropdown right :dropup="props.index!=0"
        text="Action" variant="outline-info"
        style="margin:-8px 0px -8px 0px; height:36px;" boundary='window' >
          <b-dropdown-item v-for="(jun, index) in Array.from(Array(2 + 
          Number(users[props.formattedRow.index].category == '球団'
          && CheckStamem(users[props.formattedRow.index].team, users[props.formattedRow.index].nen)
          )).keys()
          )" :key="uuid(tempplayers[0])+jun"
          @click="ListAction(jun, users[props.formattedRow.index])"
          variant="info" style="position: relative;overflow: visible;"
          >
          <span v-if="jun==0">控えに追加</span>
          <span v-else-if="jun==1">1～9番にコピー</span>
          <span v-else-if="jun==2">スタメンをセット</span>
          </b-dropdown-item>
        </b-dropdown>
      </span>
      <span v-else-if="props.column.field == 'nen'">
        <a class="link" @click="$store.commit('updateValue', {vals: props.formattedRow[props.column.field], keyname: 'inputYear'});">
          {{props.formattedRow[props.column.field]}}
        </a>
      </span>
      <span v-else-if="props.column.field == 'team'">
        <a class="link" @click="$store.commit('updateValue',
        {vals: teamID(props.formattedRow[props.column.field]), keyname: 'inputTeam'});">
          {{props.formattedRow[props.column.field]}}
        </a>
      </span>
      <span v-else-if="props.column.field == 'name'" class="table_row table_name">
        {{setTempplayers(props)}}
        <draggable v-model="tempplayers[props.index]" :animation="30"
        :group="{ name: 'items', pull: 'clone', put: false}"
        @choose="setTempPlayerData(props.index)"
        :scroll-sensitivity="100"
        :force-fallback="true"
        >
          <div v-for="item in tempplayers[props.index]" :key="uuid(tempplayers[0])"
          class="item">
            <div class="subject">{{item.name}}</div>
            <div class="righter"><img src="../assets/dragg.svg" width="20" height="20"></div>
          </div>
        </draggable>
      </span>
      <span v-else>
        {{props.formattedRow[props.column.field]}}
      </span>
    </template>
    </vue-good-table>
    <br>
  </div>
</template>

<script>
import Mixin from '../mixins/utility'
import draggable from 'vuedraggable'
export default {
  name: 'result',
  mixins: [Mixin],
  components: { draggable },
  data(){
    return {
      tempplayers:{}
      ,
      searchOptions: {
        enabled: true,
        placeholder: 'テーブルを検索します',
        searchFn: this.searchFn,
      },
      columns: [
        {
          label: '年',
          field: 'nen',
          type: 'number',
        },
        {
          label: '名前',
        　field: 'name',
          type: 'string',
        },
        {
          label: '球団',
          field: 'team',
          type: 'string',
        },
        {
          label: '打数',
          field: 'AB',
          type: 'number',
        },
        {
          label: '安打',
          field: 'H',
          type: 'number',
        },
        {
          label: '本塁',
          field: 'HR',
          type: 'number',
        },
        {
          label: '打点',
          field: 'RBI',
          type: 'number',
        },
        {
          label: '打率',
          field: 'AVG',
          type: 'number',
        },
        {
          label: '出塁',
          field: 'OBP',
          type: 'number',
        },
        {
          label: '長打',
          field: 'SLG',
          type: 'number',
        },
        {
          label: 'OPS',
          field: 'OPS',
          type: 'number',
        },
        {
          label: '操作',
          field: 'index',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    tolist () {
      return function (p){
        return [p] 
      }
    },
    rows () {
      return this.result_players
    },
    setTempplayers () {
      return function (p) {
        const player = p.formattedRow//
        const getplayer = this.users[player.index]
        this.tempplayers[p.index] = [this.setRecord(getplayer)]
      }
    },
    setTempPlayerData () {
      return function (i) {
        const player = this.tempplayers[i]
        return 0
      }
    },
  },
  method: {
    searchFn (row, col, cellValue, searchTerm){
      return false//cellValue === 'my value';
    },
    handleClone (item) {
      // Create a fresh copy of item
      let cloneMe = JSON.parse(JSON.stringify(item));
      //let cloneMe = this.setRecord(item);
      
      this.$delete(cloneMe, 'uid');

      return cloneMe;
    },
    filterFn: function(data, filterString) {
      var x = filterString.split(' ')
      console.log(data)
      console.log(x)
      return data >= x[1];
    }
  }
};
</script>

<style scoped>
.link {
  color: #2d918d;
  text-decoration : underline;
}
.item { 
  font-weight: bold;
}
.item:hover {
cursor: grab;
}
.item:active {
cursor: grabbing;
}
b-dropdown-item {
}
</style>



// WEBPACK FOOTER //
// src/components/seachresult.vue